export const pollServer = (
  start: (pollInterval: number) => void,
  stop: () => void,
  duration = 8000
) => {
  start(500);
  setTimeout(() => {
    stop();
  }, duration);
};
